import React, { useState, useContext } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Alert,
  InputAdornment,
  IconButton
} from "@mui/material";
import { Link as MuiLink } from "@mui/material";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import Header from "../../components/Header";
import axios from "axios";
import Cookies from "js-cookie";
import { AuthContext } from "../utils/AuthContext";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const LoginForm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const { loading, error, dispatch } = useContext(AuthContext);

  const handleChange = (e) => {
    setCredentials((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch({ type: "LOGIN_START" });

    try {
      const res = await axios.post(
        "https://api.komorotel.com/api/auth/login",
        credentials,
        {
          withCredentials:true
        }
      );

      

      dispatch({ type: "LOGIN_SUCCESS", payload: res.data.user });

      // 🔥 REDIRECTION INTELLIGENTE
      if (location.state?.from === "checkout") {
        navigate(
          `/checkout?room=${location.state.roomId}&checkIn=${location.state.checkIn}&checkOut=${location.state.checkOut}`
        );
      } else {
        navigate("/");
      }

    } catch (err) {
      dispatch({ type: "LOGIN_ERROR", payload: err.response?.data });
    }
  };

  return (
    <>
      <Header disabled />

      <Container maxWidth="sm">
        <Box
          sx={{
            mt: 16,
            p: 5,
            borderRadius: 4,
            backgroundColor: "#fff",
            boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
          }}
        >
          {/* TITLE */}
          <Typography variant="h4" fontWeight="bold" mb={1}>
            Connexion
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            Accédez à votre compte Komorotel
          </Typography>

          <Box component="form" onSubmit={handleSubmit}>

            <TextField
              fullWidth
              label="Email"
              id="email"
              margin="normal"
              onChange={handleChange}
            />

            <TextField
              fullWidth
              label="Mot de passe"
              id="password"
              type={showPassword ? "text" : "password"}
              margin="normal"
              onChange={handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
              <MuiLink
                component={RouterLink}
                to="/forgot-password"
                underline="hover"
                sx={{ fontSize: "0.9rem" }}
              >
                Mot de passe oublié ?
              </MuiLink>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error.message || "Une erreur est survenue."}
              </Alert>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                py: 1.5,
                borderRadius: 2,
                backgroundColor: "#3A9D23",
                "&:hover": { backgroundColor: "#33891E" },
              }}
              disabled={loading}
            >
              {loading ? "Connexion..." : "Se connecter"}
            </Button>

          </Box>

          {/* SIGNUP LINK */}
          <Typography variant="body2" textAlign="center" mt={3}>
            Pas encore de compte ?{" "}
            <a href="/signup" style={{ color: "#3A9D23" }}>
              Créer un compte
            </a>
          </Typography>

        </Box>
      </Container>
    </>
  );
};

export default LoginForm;